<template>
    <v-dialog v-model="formdialog">
        <v-card>
            <v-container>
                <h1>{{ formTitle }}</h1>
                <v-form @submit.prevent="">
                    <v-autocomplete
                        label="Product Name"
                        v-model="batch.productname"
                        :items="products"
                        item-title="productnames_productname"
                        item-value="productnames_productname"
                        density="comfortable"
                        placeholder="Product name"
                        auto-select-first
                        item-props
                    ></v-autocomplete>
                    <v-text-field
                        v-model="batch.batchno"
                        :counter="11"
                        label="Batch No"
                        required
                    ></v-text-field>
                    <v-text-field
                        v-model="batch.mfgdate"
                        label="Mfg Date"
                        type='date'
                        required
                    ></v-text-field>
                    <v-text-field
                        v-model="batch.expdate"
                        label="Exp Date"
                        type='date'
                        required
                    ></v-text-field>
                    
                    <v-text-field
                        v-model="batch.mrp"
                        :counter="10"
                        label="MRP"
                        type='number'
                        required
                        v-on:change="batch.mrp = Number(batch.mrp)"
                    ></v-text-field>
                    <v-text-field
                        v-model="batch.rate"
                        :counter="10"
                        label="Rate"
                        type='number'
                        required
                        v-on:change="batch.rate = Number(batch.rate)"
                    ></v-text-field>
                    <v-row >
                        <v-col>
                            <v-checkbox
                            v-model="updategm"
                            :label="gmchkboxlabel"
                            color="red-darken-3"
                            :disabled="disablegmcheckbox"
                            ></v-checkbox>
                        </v-col>
                        <v-col>
                            <v-checkbox
                            v-model="updategmw"
                            :label="gmwchkboxlabel"
                            color="indigo"
                            :disabled="disablegmwcheckbox"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="auto">
                        <v-btn
                            depressed
                            color="primary"
                            type="submit"
                            @click=buttonClick()
                        >
                            Save
                        </v-btn>
                        </v-col>
                        <v-col cols="auto">
                        <v-btn
                            v-if="editedIndex != -1"
                            depressed
                            color="error"
                            type="submit"
                            @click=deleteData()
                            :disabled="deleteButtonStatus"
                        >
                            Delete
                        </v-btn>
                        </v-col>
                    </v-row>
                    
                </v-form>
                <div v-if="showMessage">
                    <ShowError @closesnackbar="closesnackbar"/>
                </div>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { ref, provide, computed, onMounted,onBeforeMount,watch } from 'vue'
import ProductService from '@/services/ProductService'
import ShowError from '@/components/Showerror'
import BatchService from '@/services/BatchService'
import ProductsalesService from '@/services/ProductsalesService'
import router from '@/router'

const props = defineProps(['showForm','editedItem','editedIndex', 'updateIDGM', 'updateIDGMW', 'gmwswitch'])
const emit = defineEmits(['closedialog'])

var formTitle = ref((props.editedIndex == -1) ? 'New Batch': 'Edit Batch')
var formdialog = ref(props.showForm)

var showMessage = ref(false)
var msgStatus = ref('primary')
var msg = ref('This is msg')

var batch = ref(props.editedItem)
var products = ref([])
var deleteButtonStatus = ref(true)

var updategm = ref(false)
var updategmw = ref(false)

var productnamesgm = ([])
var productnamesgmw = ([])
var disablegmcheckbox = ref(false)
var disablegmwcheckbox = ref(false)
var gmchkboxlabel = ref((props.editedIndex == -1) ? 'Create in GM': 'Edit in GM')
var gmwchkboxlabel = ref((props.editedIndex == -1) ? 'Create in GMW': 'Edit in GMW')


provide('msgStatus', msgStatus)
provide('msg', msg)
provide('showMessage', showMessage)


async function closedialog(){
    formdialog.value = false
    emit('closedialog')
}

async function buttonClick(){
    //console.log('Button is clicked')
    //console.log(batch.value)
    if(props.editedIndex == -1){
        await create()
    }else{
        await update()
    }
}

async function create(){
    console.log("Create is called")
    if(updategm.value){
        var checkifexists = (await BatchService.checkifexists(batch.value.productname, batch.value.batchno)).data.count
        if(checkifexists == 0){
            await creategm()
        }else{
            msg.value = "Batch Already exists in GM"
            msgStatus.value = 'error'
            showMessage.value = true
        }
        
    }
    if(updategmw.value){
        var checkifexistsgmw = (await BatchService.checkifexistsgmw(batch.value.productname, batch.value.batchno)).data.count
        if(checkifexistsgmw == 0){
            await creategmw()
        }else{
            msg.value = "Batch Already exists in GMW"
            msgStatus.value = 'error'
            showMessage.value = true
        }
        
    }
    
    formdialog.value = false
}

async function creategm(){
    try {
        await BatchService.create(batch.value)
    } catch (err) {
        msg.value = "GM error "+err.response.data.error
        msgStatus.value = 'error'
        showMessage.value = true
    }
}

async function creategmw(){
    try {
        await BatchService.creategmw(batch.value)
    } catch (err) {
        msg.value = "GMW error "+err.response.data.error
        msgStatus.value = 'error'
        showMessage.value = true
    }
}

async function update(){
    console.log("Update is called")

    if(props.updateIDGM.value != -1 && updategm.value){
        await updateGM()
    }
    if(props.updateIDGMW.value != -1 && updategmw.value){
        await updateGMW()
    }
}

async function updateGM(){
    try {
        await BatchService.update({
            productname: batch.value.productname,
            batchno: batch.value.batchno,
            mfgdate: batch.value.mfgdate,
            expdate: batch.value.expdate,
            mrp: batch.value.mrp,
            rate: batch.value.rate
        },props.updateIDGM)
        formdialog.value = false
    } catch (err) {
        msg.value = err.response.data.error
        msgStatus.value = 'error'
        showMessage.value = true
    }
}

async function updateGMW(){
    try {
        await BatchService.updategmw({
            productname: batch.value.productname,
            batchno: batch.value.batchno,
            mfgdate: batch.value.mfgdate,
            expdate: batch.value.expdate,
            mrp: batch.value.mrp,
            rate: batch.value.rate
        },props.updateIDGMW)
        formdialog.value = false
    } catch (err) {
        msg.value = err.response.data.error
        msgStatus.value = 'error'
        showMessage.value = true
    }
}

async function deleteData(){
    console.log ( "Delete Data is called")
    if(updategm.value){
        await deletegm()
    }
    if(updategmw.value){
        await deletegmw()
    }
    formdialog.value = false
}

async function deletegm(){
    try {
        await BatchService.delete(props.updateIDGM)
        
    } catch (err) {
        msg.value = err.response.data.error
        msgStatus.value = 'error'
        showMessage.value = true
    }
}
async function deletegmw(){
    try {
        await BatchService.deletegmw(props.updateIDGMW)
        
    } catch (err) {
        msg.value = err.response.data.error
        msgStatus.value = 'error'
        showMessage.value = true
    }
}

async function checkifused(){
    console.log("checking if used")
}

async function productsgm(){
    //console.log("checking if used")
    try{
        var productsgm = (await ProductService.getallnames()).data
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    productnamesgm.value = productsgm
    return productsgm
}

async function productsgmw(){
    //console.log("checking if used")
    try{
        var productsgm = (await ProductService.getallnamesgmw()).data
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    productnamesgmw.value = productsgm
    return productsgm
}

async function checkifbatchusedgm(){
    try{
        var batchusedcount = (await ProductsalesService.checkifbatchused(props.updateIDGM)).data
        
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    return batchusedcount.count
}

async function checkifbatchusedgmw(){
    try{
        var batchusedcount = (await ProductsalesService.checkifbatchusedgmw(props.updateIDGMW)).data
        
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    return batchusedcount.count
}

function closesnackbar (){
    showMessage.value = false
}

watch(formdialog, async(val)=>{
    if(formdialog.value===false){
    emit('closedialog')
    }
})

watch(() => [batch.value.mrp, batch.value.productname], async(val)=>{
    var newmrp = batch.value.mrp
    var gstrate = products.value.filter(function (obj) {
            return obj.productnames_productname === batch.value.productname;
        })[0].hsn.hsn_igstrate
    var rate = ((newmrp - newmrp*0.2)/((100 + Number(gstrate))/100))
    batch.value.rate = Math.round(rate*100)/100
    //console.log(val)
})

onBeforeMount(async () => {
    
    var gmproducts = await productsgm()
    var gmwproducts = await productsgmw()

    if(props.gmwswitch){
        products.value = gmwproducts
    }else{
        products.value = gmproducts
    }

    var batchusedgm = await checkifbatchusedgm()
    var batchusedgmw = await checkifbatchusedgmw()

    if(batchusedgm == 0 && batchusedgmw == 0){
        deleteButtonStatus.value = false
    }else{
        showMessage.value = true
        msgStatus.value = 'primary'
        msg.value = "Batch is in use. Can not Delete"
    }

    var productname = props.editedItem.productname

    var productexistsingm = await productExists(productname, gmproducts)
    var productexistsingmw = await productExists(productname, gmwproducts)

    if(props.editedIndex != -1){
        if(!productexistsingm || props.updateIDGM == -1){
            disablegmcheckbox.value = true
        }
    }
    
    if(props.editedIndex != -1){
        if(!productexistsingmw || props.updateIDGMW == -1){
            disablegmwcheckbox.value = true
        }
    }

    

})

async function productExists(productname,arr) {
    return arr.some(function(el) {
        return el.productnames_productname === productname;
    }); 
}

</script>
